import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import AddEditAutomaticDiscount from "../components/discounts/automaticDiscount/addEditAutomaticDiscount";
import ViewDiscount from "../components/discounts/shared/viewDiscount";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";
import CommonDiscountList from "../shared/commonComponents/commonDiscountList";

const AutomaticDiscount = () => <CommonDiscountList type="Automatic" />

/* Functional component to hold all the pages in a stack navigator */
const AutomaticDiscountStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();
    return (
        <AppStack.Navigator
            initialRouteName={"AutomaticDiscount"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="AutomaticDiscount" component={AutomaticDiscount} />
            <AppStack.Screen name="AddEditAutomaticDiscount" component={AddEditAutomaticDiscount} />
            <AppStack.Screen name="ViewDiscount" component={ViewDiscount} />
        </AppStack.Navigator>
    );
};

export default AutomaticDiscountStack;